import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

let getUrlFlavor = window.location.pathname;
getUrlFlavor = getUrlFlavor.split("/");
getUrlFlavor = getUrlFlavor[2];

$(".flavor-color").each(function () {
    let getFlavor = $(this).data("flavor");

    $(".flavor-color").on({
        mouseenter: function () {
            $(this).css("background-color", $(this).data("fundo"));
            $(this).find(".a-flavor-color").css("color", "#FFF");
        },
        mouseleave: function () {
            $(this).css("background-color", "#FFF");
            $(this).find(".a-flavor-color").css("color", $(this).data("fundo"));
        },
    });

    $(this).css("background-color", "#ffffff");
    $(this).css("border-style", "solid");
    $(this).css("border-width", "1px");
    $(this).css("border-color", $(this).data("fundo"));

    if (getUrlFlavor == getFlavor) {
        $(this).css("background-color", $(this).data("fundo"));
        $(this).find(".a-flavor-color").css("color", "#ffffff");
        $(this).addClass("active");
    }
});
